import React from 'react'
import PropTypes from 'prop-types'

import { FieldError, FieldHint } from 'components/FormElements'
import { AvatarPickerControl } from 'components/Controls'
import classNames from 'classnames'

export const AvatarPickerField = ({
  meta = {},
  translateParams,
  className = 'mb-3',
  hintText,
  ...props
}) => {
  const { error } = meta

  const showError = Boolean(error)

  return (
    <>
      <div
        className={classNames({
          [className]: className,
        })}
      >
        <div
          className={classNames('', {
            'is-invalid': showError,
          })}
        >
          <AvatarPickerControl {...props} />
        </div>

        {hintText && <FieldHint message={hintText} />}

        <FieldError error={error} translateParams={translateParams} showError={showError} />
      </div>
    </>
  )
}

AvatarPickerField.propTypes = {
  translateParams: PropTypes.object,
  meta: PropTypes.object,
  className: PropTypes.string,
  hintText: PropTypes.string,
}
